import { checkBoxToString, RightHelper, BaseTLTableComponent, AxiosResponse, Component,  BaseTLTableBase, UserService, UserFilter, Prop, tlISODateTimeToLocalNoSecondsString, tlPrepareForFilter } from "../../../Infrastructure/CorBase/CoreBase";

	export default abstract class UserListBase extends BaseTLTableComponent {
		selectedUserId: number = 0;
		
		userService: UserService = new UserService();

		showSelfRegistration = false;

		@Prop({ type: Boolean, required: false, default: false }) isShowModal?: boolean; //zobrazení v modálním dialogu

		allowAdd() {
			return RightHelper.currentUserHasRight('COR_User_Create');
		}

		itemsAnswer = [
			{ value: this.$t('global.answerYes').toString(), text: this.$t('global.answerYes').toString() },
			{ value: this.$t('global.answerNo').toString(), text: this.$t('global.answerNo').toString() }];


		//TODO jestli by to slo rovnou pouzit předka???
	/*	selectRows(items: any) {
			super.selectRows(items);
		}
*/
		callActionClick() {
			this.isBusy = true;
			this.deleteItemsList = this.getSelectedList();
			super.deleteList();	
			this.itemsSelected = null;
			(this.$refs.usersTable as BaseTLTableBase).clearSelected();
		}

		protected deleteListServer(): Promise<AxiosResponse<any>> {
			return this.userService.deleteList(this.deleteItemsList);
		}
		
		setFields() {
			this.fields = [
				//{ key: 'id', label: this.$t('user.fieldLogin'), trans: 'user.fieldLogin', sortable: true, class: 'text-center', visible: true },
				{ key: 'login', label: this.$t('user.fieldLogin'), trans: 'user.fieldLogin', sortable: true, class: 'text-left', visible: true, design: 'detail' },
				{ key: 'idStateNavigationName', label: this.$t('user.fieldState'), trans: 'user.fieldState', sortable: true, class: 'text-left', visible: true },
			//	{ key: 'lastLoginDateTime', label: this.$t('user.fieldLastLogin'), trans: 'user.fieldLastLogin', sortable: true, class: 'text-center', formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x) },
			];
			if (this.$store.state.selfRegistration) {
				this.fields.push({ key: 'selfRegisteredText', label: this.$t('user.fieldselfRegistered'), trans: 'user.fieldselfRegistered', sortable: true, class: 'text-left', visible: true });
			}
			this.fields.push({ key: 'lastLoginDateTime', label: this.$t('user.fieldLastLogin'), trans: 'user.fieldLastLogin', sortable: true, class: 'text-left', formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x) });

			if (this.isShowModal == false) {
				this.fields.push({ key: 'actions', label: this.$t('user.fieldActions'), trans: 'user.fieldActions', sortable: false, class: 'width120 text-right', visible: true, thClass: 'lastColumnMichael' });
			}
			
		};

			//filtry
		setfilters(value: any) {
			if (value != null && value[0].lang == this.filters[0].lang) {
				this.filters = value;
			}
			else {
				this.filters = [
					{ key: 'login', label: this.$t('user.fieldLogin'), trans: 'user.fieldLogin', selected: false, value: null, type: 'text', lang: this.$store.state.currentLanguage },
					{ key: 'idStateNavigationName', label: this.$t('user.fieldState'), trans: 'user.fieldState', selected: false, value: null, type: 'text', enum: 'ENU_COR_User_State', useEnum: true, refItem: 'idStateNavigationName' },
					{ key: 'selfRegisteredText', label: this.$t('user.fieldselfRegistered'), trans: 'user.fieldselfRegistered', selected: false, value: null, type: 'text', useOwnEnumsSend: true, useOwnEnumsSendArray: this.itemsAnswer },
					{ key: 'lastLoginDate2', label: this.$t('user.filterLastLoginFrom'), trans: 'user.filterLastLoginFrom', selected: false, value: null, type: 'datetime', moreThan: true, refItem: 'lastLoginDateTime'},
					{ key: 'lastLoginDate3', label: this.$t('user.filterLastLogin'), trans: 'user.filterLastLogin', selected: false, value: null, type: 'datetime', moreThan: false, refItem: 'lastLoginDateTime' },
				];
			}
		}


		fetchDataFromServer(): Promise<AxiosResponse<any>> {
			return this.userService.getAllByFilter(new UserFilter(this.$store.state.idTenant,false));
		}

		//zatím nepotrebujeme
		fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return this.fetchDataFromServer();
		}

		refreshItems(items: any[], refreshData: any[]) {
			return items;
		}


		prepareItems(items: any[]) {
			for (var i = 0; i < items.length; i++) {
				items[i].lastLoginDateTime = items[i].lastLoginDate;
				items[i].lastLoginDate2 = items[i].lastLoginDate;
				items[i].lastLoginDate3 = items[i].lastLoginDate;
				items[i].selfRegisteredText = this.$t(checkBoxToString(items[i].selfRegistered)).toString();
			}
		}

	};